import * as React from 'react';
import SubscriptionService from '../services/SubscriptionService';
import {identity} from '../../core/auth/identityAuth'
import Loading from '../../shared/components/loading/Loading';
import BreadCrumb from '../../shared/components/BreadCrumb'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Asset from '../models/Asset';
import Environment from '../models/Environment';
import AssetCard from '../components/AssetCard'
import IconButton from '@material-ui/core/IconButton'
import ListIcon from '@material-ui/icons/Menu'
import GridIcon from '@material-ui/icons/Apps'
import SearchIcon from '@material-ui/icons/Search'
import Input from '@material-ui/core/Input'
import Hidden from '@material-ui/core/Hidden'

import SiteCoreService from '../../../modules/core/services/SiteCoreService';
import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";

const siteCoreService = SiteCoreService.Instance;

const subscriptionService = SubscriptionService.Instance;

const styles = {
  buttonIcon: {
    width: '80%',
    height: '80%'
  },
  IconButton: {
    width: 40,
    height: 40
  },

};

interface IState {
  subscriptions: Asset[];
  isLoading: boolean;
  isList: boolean;
  searchText: string;
  sitecoreAssets: ISitecoreAsset[];
}

class Subscriptions extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      subscriptions: [],
      isLoading: true,
      isList: false,
      searchText: "",
      sitecoreAssets: [],
    }
  }

  public async componentDidMount() {
    const [subscriptions, sitecoreAssets] : [Asset[], ISitecoreAsset[]] = await Promise.all([
      subscriptionService.getAssetSubscriptions(),
      siteCoreService.getAllSiteCoreAssets()
    ])
    
    this.setState({ sitecoreAssets, subscriptions, isLoading: false });
  }
  
  public inSearch(searchString: string, regex: string) {
    if (searchString === "") {
      return true;
    }
    searchString = searchString.toLowerCase();
    regex = regex.toLowerCase();
    try {
      return searchString.search(regex) !== -1;
    } catch (error) {
      return false;
    }

  }

  public render() {
    const { classes } = this.props;
    const { isLoading, searchText, subscriptions, sitecoreAssets, isList } = this.state;
    
    return (
      <div>
        <Grid container justify="space-between" spacing={16} className="padding-bottom-24">
          <Grid item>
            <Typography variant='title'>
              {identity['nxt:entity:name']}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              <BreadCrumb
                value='Console'
                to='/'
              />
              Subscriptions
            </Typography>
          </Grid>
          <Grid item>
            <Input
              value={searchText}
              onChange={(e) => this.setState({ searchText: e.target.value })}
              endAdornment={<SearchIcon />}
            />
            <Hidden smDown>
              <IconButton
                className={classes.IconButton}
                color="default"
                onClick={() => this.setState({ isList: true })}
              >
                <ListIcon className={classes.buttonIcon} />
              </IconButton>
              <IconButton
                className={classes.IconButton}
                color="default"
                onClick={() => this.setState({ isList: false })}
              >
                <GridIcon className={classes.buttonIcon} />
              </IconButton>
            </Hidden>
          </Grid>
        </Grid>

        {isLoading &&
          <Loading />
        }
        {!isLoading &&
          <div>
            {subscriptions.length < 1 && 
              <div>
                <Typography>
                  Your entity is not subscribed to any data. 
                </Typography>
                {subscriptions.length < 1 && process.env.ENVIRONMENT === 'PRODUCTION' &&
                  <Typography>
                    Take a look in our <a href={process.env.REACT_APP_PUBLIC_WEBSITE_URL + "/en/market/our-marketplace/marketplace"} target="_blank">Marketplace</a> to see which data is already shared through our platform.
                  </Typography>
                }
              </div>
            }
            <Grid container spacing={isList ? 0 : 16} justify="flex-start" alignItems="stretch">
              {subscriptions.filter((asset: Asset) => this.inSearch(asset.name, searchText)).map((asset: Asset) => {
                return (
                  <Grid key={asset.id} item xs={12} sm={isList ? 12 : 6} md={isList ? 12 : 4} lg={isList ? 12 : 3}>
                    <AssetCard
                      asset={(sitecoreAssets.find(i => i.id === asset.id))}
                      ownerId={asset.owner}
                      name={asset.name}
                      horizontal={isList}
                      buttons={asset.environments.map((environment: Environment) => {
                        const name = environment.name
                        const link = '/subscriptions/' + asset.id + '/' + environment.name + '/info'
                        return { name, link }

                      })}
                    />
                  </Grid>
                )
              })}
            </Grid>
            <div className="padding-bottom-24" />
          </div>
        }
      </div>
    )
  }
}

export default withStyles(styles)(Subscriptions);


// WEBPACK FOOTER //
// ./src/modules/consumer/pages/Subscriptions.tsx